module.exports = __webpack_public_path__ + "static/media/evening_lake.172b4acf.jpg";